import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {Breadcrumb, Button, Card, Row, Steps} from 'antd'
import style from './style.css'
import Existing from './Form/Existing'
import WrappedContactDetails from '../../Main/Form/PersonalDetails'
import useTitle from '../../../elements/Hooks/useTitle'

const Step = Steps.Step

function NewClient(props) {
  useTitle('New Client')
  const {currentStep, prev, next, skip, submit, submitting} = props
  const steps = [
    {
      title: 'Search for Existing',
      content: <Existing {...props} />,
    },
    {
      title: 'Personal Details',
      content: (
        <WrappedContactDetails
          ref={props.detailsFormRef}
          {...props}
          list={props.cachedMembers.filter(m => m.kind === 'organisation')}
        />
      ),
    },
  ]
  return (
    <Fragment>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="#/clients/list">
              Clients List
            </Breadcrumb.Item>
            <Breadcrumb.Item>New Client</Breadcrumb.Item>
          </Breadcrumb>
          <h2 className={style.title}>Create new Client</h2>
          <p className={style.paragraph}>
            You can either add new client or select an individual from existing
            contact.
          </p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Steps current={currentStep}>
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="steps-content">{steps[currentStep].content}</div>
        <div
          className="steps-action"
          style={{textAlign: 'center', paddingTop: 20}}>
          {currentStep > 0 && (
            <Button style={{marginRight: 8}} onClick={prev}>
              Previous
            </Button>
          )}
          {currentStep === 0 && (
            <Button style={{width: '100px', marginRight: 8}} onClick={skip}>
              Skip
            </Button>
          )}
          {currentStep < steps.length - 1 && (
            <Button style={{width: '100px'}} type="primary" onClick={next}>
              Next
            </Button>
          )}
          {currentStep === steps.length - 1 && (
            <Button type="primary" loading={submitting} onClick={submit}>
              Create
            </Button>
          )}
        </div>
      </Card>
    </Fragment>
  )
}

NewClient.propTypes = {
  visible: PropTypes.bool,
  handleCancel: PropTypes.func,
}

NewClient.defaultProps = {visible: false}

export default NewClient
